export default "__VITE_ASSET__CGzXjk5m__"